<template>
  <div class="ocr-common-config">
    <el-card>
      <div slot="header" class="clearfix">
        <span>OCR通用配置管理</span>
        <div style="float: right;">
          <el-button type="success" size="small" @click="handleCopyToken" icon="el-icon-document-copy">一键获取Token</el-button>
          <el-button type="primary" size="small" @click="handleAdd" icon="el-icon-plus" style="margin-left: 10px;">新增配置</el-button>
        </div>
      </div>

      <!-- 配置列表 -->
      <el-table :data="configList" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column prop="configName" label="配置名称" width="200"></el-table-column>
        <el-table-column prop="configType" label="配置类型" width="120"></el-table-column>
        <el-table-column prop="fontSize" label="字体大小" width="100"></el-table-column>
        <el-table-column prop="fontColor" label="字体颜色" width="150">
          <template slot-scope="scope">
            <span :style="{backgroundColor: scope.row.fontColor, padding: '2px 8px', borderRadius: '3px', color: getContrastColor(scope.row.fontColor)}">
              {{ scope.row.fontColor }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="compress" label="压缩" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.compress === 1 ? 'success' : 'info'" size="small">
              {{ scope.row.compress === 1 ? '开' : '关' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isDefault" label="默认" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isDefault === 1 ? 'warning' : 'info'" size="small">
              {{ scope.row.isDefault === 1 ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 0 ? '正常' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)" icon="el-icon-view">查看</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)" icon="el-icon-edit">编辑</el-button>
            <el-button type="text" size="small" @click="handleSetDefault(scope.row)" icon="el-icon-star-off" v-if="scope.row.isDefault !== 1">设为默认</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" icon="el-icon-delete" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="配置名称" prop="configName">
          <el-input v-model="form.configName" placeholder="请输入配置名称"></el-input>
        </el-form-item>
        <el-form-item label="配置类型" prop="configType">
          <el-select v-model="form.configType" placeholder="请选择配置类型">
            <el-option label="BIR证件" value="BIR"></el-option>
          </el-select>
        </el-form-item>
        
        <el-divider>字体设置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="字体大小" prop="fontSize">
              <el-input-number v-model="form.fontSize" :min="6" :max="72" controls-position="right" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="字体颜色" prop="fontColor">
              <el-color-picker v-model="form.fontColor" show-alpha></el-color-picker>
              <span style="margin-left: 10px;">{{ form.fontColor }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider>显示设置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="换行阈值" prop="lineBreakThreshold">
              <el-input-number v-model="form.lineBreakThreshold" :min="500" :max="2000" :step="50" controls-position="right" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="压缩">
              <el-switch v-model="form.compress" :active-value="1" :inactive-value="0" active-text="开" inactive-text="关"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider>坐标配置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="税号坐标">
              <el-input-number v-model="form.taxNumberX" controls-position="right" placeholder="X" style="width: 45%;"></el-input-number>
              <span style="margin: 0 5px;">,</span>
              <el-input-number v-model="form.taxNumberY" controls-position="right" placeholder="Y" style="width: 45%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名坐标">
              <el-input-number v-model="form.fullNameX" controls-position="right" placeholder="X" style="width: 45%;"></el-input-number>
              <span style="margin: 0 5px;">,</span>
              <el-input-number v-model="form.fullNameY" controls-position="right" placeholder="Y" style="width: 45%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="日期坐标">
              <el-input-number v-model="form.dateOfBirthX" controls-position="right" placeholder="X" style="width: 45%;"></el-input-number>
              <span style="margin: 0 5px;">,</span>
              <el-input-number v-model="form.dateOfBirthY" controls-position="right" placeholder="Y" style="width: 45%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址坐标">
              <el-input-number v-model="form.addressX" controls-position="right" placeholder="X" style="width: 45%;"></el-input-number>
              <span style="margin: 0 5px;">,</span>
              <el-input-number v-model="form.addressY" controls-position="right" placeholder="Y" style="width: 45%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider>其他设置</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio :label="0">正常</el-radio>
                <el-radio :label="1">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'OcrCommonConfig',
  data() {
    return {
      configList: [],
      dialogVisible: false,
      dialogTitle: '新增配置',
      dialogMode: 'add',
      submitting: false,
      form: {
        configName: '',
        configType: 'BIR',
        fontSize: 20,
        fontColor: 'rgba(62, 60, 60, 1)',
        lineBreakThreshold: 1000,
        compress: 1,
        taxNumberX: 100,
        taxNumberY: 385,
        fullNameX: 400,
        fullNameY: 385,
        dateOfBirthX: 980,
        dateOfBirthY: 385,
        addressX: 200,
        addressY: 465,
        isDefault: 0,
        status: 0,
        remark: ''
      },
      rules: {
        configName: [{ required: true, message: '请输入配置名称', trigger: 'blur' }],
        configType: [{ required: true, message: '请选择配置类型', trigger: 'change' }],
        fontSize: [{ required: true, message: '请输入字体大小', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    async loadList() {
      try {
        const token = localStorage.getItem('admin_token')
        const response = await axios.get('/admin/ocr/common-config/list', {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        
        if (response.data.code === 200) {
          this.configList = response.data.data || []
        }
      } catch (error) {
        console.error('加载配置列表失败', error)
        this.$message.error('加载配置列表失败')
      }
    },
    
    handleAdd() {
      this.dialogMode = 'add'
      this.dialogTitle = '新增配置'
      this.resetForm()
      this.dialogVisible = true
    },
    
    handleView(row) {
      this.dialogMode = 'view'
      this.dialogTitle = '查看配置'
      this.form = { ...row }
      this.dialogVisible = true
    },
    
    handleEdit(row) {
      this.dialogMode = 'edit'
      this.dialogTitle = '编辑配置'
      this.form = { ...row }
      this.dialogVisible = true
    },
    
    handleDelete(row) {
      this.$confirm('确认删除此配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const token = localStorage.getItem('admin_token')
          const response = await axios.post(`/admin/ocr/common-config/delete/${row.id}`, {}, {
            headers: { 'Authorization': `Bearer ${token}` }
          })
          
          if (response.data.code === 200) {
            this.$message.success('删除成功')
            this.loadList()
          } else {
            this.$message.error(response.data.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除失败', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    
    handleSetDefault(row) {
      this.$confirm('确认将此配置设为默认吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const token = localStorage.getItem('admin_token')
          const response = await axios.post(`/admin/ocr/common-config/set-default/${row.id}`, {}, {
            headers: { 'Authorization': `Bearer ${token}` }
          })
          
          if (response.data.code === 200) {
            this.$message.success('设置成功')
            this.loadList()
          } else {
            this.$message.error(response.data.msg || '设置失败')
          }
        } catch (error) {
          console.error('设置失败', error)
          this.$message.error('设置失败')
        }
      }).catch(() => {})
    },
    
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        
        this.submitting = true
        try {
          const token = localStorage.getItem('admin_token')
          const url = this.dialogMode === 'add' ? '/admin/ocr/common-config/add' : '/admin/ocr/common-config/update'
          
          const response = await axios.post(url, this.form, {
            headers: { 'Authorization': `Bearer ${token}` }
          })
          
          if (response.data.code === 200) {
            this.$message.success(this.dialogMode === 'add' ? '新增成功' : '更新成功')
            this.dialogVisible = false
            this.loadList()
          } else {
            this.$message.error(response.data.msg || '操作失败')
          }
        } catch (error) {
          console.error('提交失败', error)
          this.$message.error('提交失败')
        } finally {
          this.submitting = false
        }
      })
    },
    
    resetForm() {
      this.form = {
        configName: '',
        configType: 'BIR',
        fontSize: 20,
        fontColor: 'rgba(62, 60, 60, 1)',
        lineBreakThreshold: 1000,
        compress: 1,
        taxNumberX: 100,
        taxNumberY: 385,
        fullNameX: 400,
        fullNameY: 385,
        dateOfBirthX: 980,
        dateOfBirthY: 385,
        addressX: 200,
        addressY: 465,
        isDefault: 0,
        status: 0,
        remark: ''
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    
    handleDialogClose() {
      this.resetForm()
    },
    
    handleCopyToken() {
      const token = localStorage.getItem('admin_token')
      
      if (!token) {
        this.$message.warning('未找到Token，请先登录！')
        return
      }
      
      // 复制到剪贴板
      const textarea = document.createElement('textarea')
      textarea.value = token
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$message({
            type: 'success',
            message: 'Token已复制到剪贴板！',
            duration: 2000,
            showClose: true
          })
          
          // 显示Token预览
          this.$alert(
            `<div style="word-break: break-all; max-height: 300px; overflow-y: auto; padding: 10px; background: #f5f5f5; border-radius: 4px; font-family: monospace; font-size: 12px;">${token}</div>`,
            'Token已复制',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              customClass: 'token-preview-dialog'
            }
          )
        } else {
          throw new Error('复制失败')
        }
      } catch (err) {
        this.$message.error('复制失败，请手动复制：' + token)
      } finally {
        document.body.removeChild(textarea)
      }
    },
    
    getContrastColor(hexColor) {
      if (!hexColor) return '#000'
      
      let color = hexColor.replace('#', '')
      if (hexColor.startsWith('rgba')) {
        const match = hexColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/)
        if (match) {
          const r = parseInt(match[1])
          const g = parseInt(match[2])
          const b = parseInt(match[3])
          const brightness = (r * 299 + g * 587 + b * 114) / 1000
          return brightness > 128 ? '#000000' : '#FFFFFF'
        }
      }
      
      const r = parseInt(color.substr(0, 2), 16)
      const g = parseInt(color.substr(2, 2), 16)
      const b = parseInt(color.substr(4, 2), 16)
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      
      return brightness > 128 ? '#000000' : '#FFFFFF'
    }
  }
}
</script>

<style scoped>
.ocr-common-config {
  padding: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>

<style>
/* Token预览对话框样式 */
.token-preview-dialog .el-message-box__message {
  padding: 0;
}

.token-preview-dialog .el-message-box__message p {
  margin: 0;
}
</style>
